import React from 'react'
import { motion } from 'framer-motion'
import SafeIcon from '../../common/SafeIcon'
import LoadingSpinner from '../ui/LoadingSpinner'
import * as FiIcons from 'react-icons/fi'

const { FiChevronLeft, FiChevronRight, FiCheck } = FiIcons

const CourseNavigation = ({ 
  currentLesson, 
  allLessons, 
  isLessonComplete, 
  canMarkComplete, 
  completingLesson, 
  onPrevious, 
  onNext, 
  onMarkComplete 
}) => {
  const currentIndex = allLessons.findIndex(lesson => lesson.id === currentLesson.id)
  const hasPrevious = currentIndex > 0
  const hasNext = currentIndex < allLessons.length - 1

  return (
    <div className="bg-white border-t border-gray-200 px-6 py-4">
      <div className="flex items-center justify-between">
        {/* Previous Button */}
        <button
          onClick={onPrevious}
          disabled={!hasPrevious}
          className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          <SafeIcon icon={FiChevronLeft} className="w-4 h-4" />
          <span>Previous</span>
        </button>

        {/* Mark Complete Button */}
        <div className="flex items-center space-x-4">
          {!isLessonComplete && (
            <motion.button
              onClick={onMarkComplete}
              disabled={!canMarkComplete || completingLesson}
              className="px-6 py-3 bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center space-x-2"
              whileHover={{ scale: canMarkComplete ? 1.05 : 1 }}
              whileTap={{ scale: canMarkComplete ? 0.95 : 1 }}
            >
              {completingLesson ? (
                <LoadingSpinner size="sm" />
              ) : (
                <SafeIcon icon={FiCheck} className="w-4 h-4" />
              )}
              <span>
                {completingLesson ? 'Marking Complete...' : 'Mark Complete'}
              </span>
            </motion.button>
          )}

          {isLessonComplete && (
            <div className="flex items-center space-x-2 text-green-600">
              <SafeIcon icon={FiCheck} className="w-5 h-5" />
              <span className="font-medium">Completed</span>
            </div>
          )}

          {!canMarkComplete && (
            <p className="text-sm text-amber-600">
              Complete the quiz to mark this lesson as done
            </p>
          )}
        </div>

        {/* Next Button */}
        <button
          onClick={onNext}
          disabled={!hasNext}
          className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          <span>Next</span>
          <SafeIcon icon={FiChevronRight} className="w-4 h-4" />
        </button>
      </div>

      {/* Keyboard Shortcuts Hint */}
      <div className="mt-3 pt-3 border-t border-gray-100">
        <div className="flex justify-center">
          <div className="text-xs text-gray-500 space-x-4">
            <span><kbd className="px-1 py-0.5 bg-gray-100 rounded text-xs">P</kbd> Previous</span>
            <span><kbd className="px-1 py-0.5 bg-gray-100 rounded text-xs">N</kbd> Next</span>
            <span><kbd className="px-1 py-0.5 bg-gray-100 rounded text-xs">M</kbd> Mark Complete</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CourseNavigation